import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import * as React from 'react'

type Props = {
	day: string
	handleSubmit: (day: string) => void
	handleSubmitToday: () => void
	isToday: boolean
}

class LogDateSelector extends React.Component<Props> {
	render() {
		const { props } = this

		return (
			<>
				<TextField
					id="log_view_date"
					size="small"
					type="date"
					value={props.day}
					InputLabelProps={{}}
					onChange={(e) => {
						props.handleSubmit(e.target.value)
					}}
				/>

				{/* 今日以外を表示中のときだけ小さく出す（今日の間は非表示） */}
				{!props.isToday && (
					<Button
						onClick={props.handleSubmitToday}
						variant="outlined"
						size="small"
						sx={{ whiteSpace: 'nowrap' }}
					>
						今日に戻る
					</Button>
				)}
			</>
		)
	}
}

export default LogDateSelector
